/**
 * @generated SignedSource<<d1b47504b0165d29b2c3c103a0a507b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraNumberFieldFormatStyle = "CURRENCY" | "DECIMAL" | "DURATION" | "PERCENT" | "UNIT" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JiraNumberField_Platform$data = {
  readonly __typename: "JiraNumberField";
  readonly fieldConfig: {
    readonly isEditable: boolean | null;
    readonly isRequired: boolean | null;
  } | null;
  readonly formatConfig: {
    readonly formatStyle: JiraNumberFieldFormatStyle | null;
    readonly formatUnit: string | null;
  } | null;
  readonly name: string;
  readonly number: number | null;
  readonly " $fragmentType": "JiraNumberField_Platform";
};
export type JiraNumberField_Platform$key = {
  readonly " $data"?: JiraNumberField_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraNumberField_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraNumberField_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "kind": "ScalarField",
          "name": "isRequired"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "number"
    },
    {
      "concreteType": "JiraNumberFieldFormatConfig",
      "kind": "LinkedField",
      "name": "formatConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "formatStyle"
        },
        {
          "kind": "ScalarField",
          "name": "formatUnit"
        }
      ]
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "aefa4c52f7440a76d4e89d6349d58fe2";

export default node;
